<template>
  <div class="abs-pa" >
   <el-form-item :label="$teras.lang.paName" >
      <el-select v-model="$abs.row.pa" style="width:100%">
        <el-option v-for="item in $teras.autori" :label="item.cognome+' '+item.nome" :value="item.id" :key="item.id"></el-option>
      </el-select>  
    </el-form-item>

    <div class="row">
        <div class="col s6">
            <el-form-item :label="$teras.lang.email" prop="paemail">
                <el-input  v-model="$abs.row.paemail"></el-input>
            </el-form-item>
        </div>
        <div class="col s6">
            <el-form-item :label="$teras.lang.cellulare" prop="pacellulare">
                <el-input  v-model="$abs.row.pacellulare"></el-input>
            </el-form-item>
        </div>
    </div>

    <el-form-item :label="$teras.lang.codicefiscale" v-if="$teras.evento.pacodicefiscale==1" prop="pacodicefiscale">
      <el-input  v-model.trim="$abs.row.pacodicefiscale"></el-input>  
    </el-form-item>

    <el-form-item :label="$teras.lang.annonascita"  v-if="$teras.evento.panato==1" prop="panato">
      <el-select v-model="$abs.row.panato" style="width:100%">
        <el-option v-for="item in annonascita" :label="item" :value="item" :key="item.id"></el-option>
      </el-select>  
    </el-form-item>

    <el-form-item :label="$teras.lang.categoriaprofessionale"  v-if="$teras.evento.pacategoriaprofessionale==1" prop="pacategoriaprofessionale">
      <el-select v-model="$abs.row.pacategoriaprofessionale" style="width:100%">
        <el-option v-for="item in $teras.categoriaprofessionale" :label="item['nome_'+$teras.language]" :value="item.id" :key="item.id"></el-option>
      </el-select>  
    </el-form-item>

    <el-form-item :label="$teras.lang.regionelavoro" v-if="$teras.evento.paregionelavoro==1" prop="paregionelavoro">
      <el-select v-model="$abs.row.paregionelavoro" style="width:100%">
        <el-option v-for="item in $teras.regione" :label="item['nome_'+$teras.language]" :value="item.id" :key="item.id"></el-option>
        <!-- <el-option :label="'ESTERO'" :value="99" :key="99">ESTERO</el-option> -->
      </el-select>  
    </el-form-item>   

    <el-form-item :label="$teras.lang.nazionelavoro"  v-if="$teras.evento.panazionelavoro==1" prop="panazionelavoro">
      <el-select v-model="$abs.row.panazionelavoro" style="width:100%">
        <el-option v-for="item in $teras.nazione" :label="item['nome_'+$teras.language]" :value="item.id" :key="item.id"></el-option>
      </el-select>  
    </el-form-item>

    <el-form-item :label="$teras.lang.socio"  v-if="$teras.evento.paassociazione!=''" prop="paassociazione">
      <el-select v-model="$abs.row.paassociazione" style="width:100%">
        <el-option label="Non socio" :value="-1"></el-option> 
        <el-option v-for="item in $teras.associazioni" :label="item['nome_'+$teras.language]" :value="item.id" :key="item.id"></el-option>
      </el-select>  
    </el-form-item>


<!--
Aggiungere Regione di lavoro
Aggiungere categoria professionale (l’attivazione dal back office deve essere autonoma da parte dlel’ares – no intervento teras)
Aggiungere autocertificazione socio/non socio società scientifica del congresso (l’attivazione e la società scientifica devono essere autonome da parte dell’ares)
Conflitto di interessi (es. Varese) - accettazione
-->
   

  </div>
</template>

<script>

export default {
  name: 'abs-primoautore',
  components: {
  },
  created () {
    console.log("Arrivo al abs-primoautore.vue");
  },
  computed:{
    annonascita: function(){
        var year = new Date().getFullYear()
        var arr = []
        for(var i = year-82; i <= year-18; i++) 
            arr.push(parseInt(i))
        return arr
    }

  },
  methods: {
    affiliazione(id){
        for ( const affiliazione of this.$teras.affiliazioni){
            //console.log(affiliazione)
            if(affiliazione.id == id){
            return this.$teras.affiliazioni.indexOf(affiliazione)+1
            }
        }
        return $teras.lang.errore
      },
    onEnd(){
    },
    onEdit(autore){
      this.autore.id=autore.id
      this.autore.cognome=autore.cognome
      this.autore.nome=autore.nome
      this.autore.affiliazione=autore.affiliazione
    },
    delNow(){
      for ( const autore of this.$teras.autori){
        //console.log(autore)
        if(autore.id == this.autore.id){
          console.log(this.$teras.autori.indexOf(autore))
          this.$teras.autori.splice(this.$teras.autori.indexOf(autore),1)
          this.reset()
        }
      }
    },
    addNow(){
      this.autore.id = this.$teras.autori.length
      this.$teras.autori.push({id:this.autore.id,cognome:this.autore.cognome,nome:this.autore.nome,affiliazione:this.autore.affiliazione})
      this.reset()
    },
    editNow(){
      for (let autore of this.$teras.autori)
        if(autore.id == this.autore.id){
          autore.cognome=this.autore.cognome
          autore.nome=this.autore.nome
          autore.affiliazione=this.autore.affiliazione
        }
      this.reset()
    },
    reset(){
      this.autore.id=-1
      this.autore.cognome=''
      this.autore.nome=''
      this.autore.affiliazione = ''
    }
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// Abs-primoautore.vue?346519b7